<template>
  <qr-reader></qr-reader>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue'
import QrReader from "@/components/QrReader.vue";

export default {
  name: 'HomeView',
  components: {
    QrReader,
    HelloWorld
  }
}
</script>
